import {
  AppraisalCardGetProps,
  AppraisalCardResponse,
} from '../../../../types/Finance/AppraisalCardUpload/AppraisalCradTypes'
import {
  getAuthenticatedRequestConfig,
  useAxios,
} from '../../../../utils/apiUtils'
import { AllowedHttpMethods, AppraisalCardUploadAPIConfig } from '../../apiList'

const getAppraisalFiles = async (
  props: AppraisalCardGetProps,
): Promise<AppraisalCardResponse> => {
  const requestConfig = getAuthenticatedRequestConfig({
    url: AppraisalCardUploadAPIConfig.getAppraisalFiles,
    method: AllowedHttpMethods.get,
    params: {
      startIndex: props.startIndex,
      endIndex: props.endIndex,
      year: props.year,
      search: props.search,
      status: props?.status,
    },
  })

  const response = await useAxios(requestConfig)
  return response.data
}

const downloadAppraisalFile = async ({
  empId,
  year,
  fullName,
}: {
  empId: number
  year: string
  fullName: string
}): Promise<Blob | undefined> => {
  const requestConfig = getAuthenticatedRequestConfig({
    url: AppraisalCardUploadAPIConfig.downloadAppraisalFile,
    method: AllowedHttpMethods.get,
    params: {
      empId,
      year,
      fullName,
    },
    responseType: 'blob',
  })
  const response = await useAxios(requestConfig)
  return response.data
}

const saveAppraisalFileForYear = async ({
  empId,
  year,
  fullName,
}: {
  empId: number
  year: string
  fullName: string
}): Promise<number | undefined> => {
  const requestConfig = getAuthenticatedRequestConfig({
    url: AppraisalCardUploadAPIConfig.saveAppraisalFileForYear,
    method: AllowedHttpMethods.post,
    params: {
      empId,
      year,
      fullName,
    },
  })

  const response = await useAxios(requestConfig)
  return response.data
}

export const appraisalCardAPI = {
  saveAppraisalFileForYear,
  downloadAppraisalFile,
  getAppraisalFiles,
}
